import { render, staticRenderFns } from "./ViewDocumentsDetail.vue?vue&type=template&id=09016302"
import script from "./ViewDocumentsDetail.vue?vue&type=script&lang=js"
export * from "./ViewDocumentsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports